import * as api from "@/api/williams/scopesOfWork";
import { queryKeys } from "../../queryKeys";
import { ScopeOfWorkStatus } from "@/api/williams/scopesOfWork";
import { useDefaultScope } from "./useDefaultScope";
import { usePinScope } from "./usePinScope";
import { useQueryClient } from "react-query";
import { useSaveScope } from "./useSaveScope";
import { v4 as uuid } from "uuid";

export function useDuplicateScope() {
  const client = useQueryClient();
  const save = useSaveScope();
  const defaults = useDefaultScope();
  const pin = usePinScope();

  return async function duplicate(id: string) {
    const scope = await api.getScopeOfWorkById(id);

    const duplicate = {
      id: uuid(),
      number: defaults.data?.number ?? "",
      description: `Duplicate of ${scope.number}`,
      locked: false,
      template: scope.template,
      owner: defaults.data?.owner,
      reportDate: new Date().toISOString().substring(0, 10),
      status: ScopeOfWorkStatus.New,
      welders: scope.welders,
      inServiceWelding: scope.inServiceWelding,
      allowQualificationsByNde: scope.allowQualificationsByNde,
      applyRepairWelderQualReqs: scope.applyRepairWelderQualReqs,
      newYorkProject: scope.newYorkProject,
      project: scope.project,
      weldingSpecialistId: scope.weldingSpecialistId,
      commonScopeOfWorkId: scope.commonScopeOfWorkId,
      contractorId: scope.contractorId,
      constructionCode: scope.constructionCode,
      wpsCode: scope.wpsCode,
      service: scope.service,
      materials: scope.materials,
      thickestGrooveWeld: scope.thickestGrooveWeld,
      smallestGrooveWeld: scope.smallestGrooveWeld,
      continuityType: scope.continuityType,
      regions: scope.regions,
    };

    const response = await save.mutateAsync(duplicate);
    pin.mutate(response.id);

    // Add duplicate to the cache.
    client.setQueryData(queryKeys.scopeOfWork.single(response.id), response);
  };
}
